<template>
    <div class="pa-4">
        <v-expansion-panels flat>
            <v-row>
                <v-col v-for="ticket, index in filteredTickets" :key="ticket.id" cols="12" md="6">
                    <v-expansion-panel>
                        <v-expansion-panel-header
                            ripple
                            color="grey lighten-3"
                        >
                            <v-row dense class="align-center">
                                <v-col cols="2">
                                    <h2 class="font-weight-light"><strong>{{ ticket.numIncidencia }}</strong></h2>
                                </v-col>
                                <v-col cols="2">
                                    <p><strong>Usuario: </strong>{{ ticket.nif }}</p>
                                </v-col>
                                <v-col cols="2">
                                    <p><strong>Estado: </strong>{{ ticket.estado.titulo }}</p>
                                </v-col>
                                <v-col cols="3">
                                    <p><strong>Fecha de creación: </strong>{{ formatDateLarge(ticket.fecha) }}</p>
                                </v-col>
                                <v-col cols="3">
                                    <p><strong>Fecha de cierre: </strong>{{ formatDateLarge(ticket.fechaCierre) }}</p>
                                </v-col>
                            </v-row>
                            <template v-slot:actions>
                                <v-icon color="primary">
                                    mdi-ticket
                                </v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                                <v-card elevation="0">
                                <v-card-title>
                                    <v-row>
                                        <v-col>
                                            <strong>Segmentación: </strong><p class="font-weight-light">{{ticket.segmentacionCliente}}</p>
                                        </v-col>
                                        <v-col>
                                            <strong>Tipo de Cliente: </strong><p class="font-weight-light">{{ticket.tipoCliente}}</p>
                                        </v-col>
                                        <v-col>
                                            <strong>Operación: </strong><p class="font-weight-light">{{ticket.tipoOperacion}}</p>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                    <v-card-text>
                                        <v-card elevation="0" style="background-color: rgb(223, 223, 223);" class="pa-6 ma-4" v-for="upload in ticket.ticketDetalles">
                                            <v-row>
                                                <v-col cols="4">ID:</v-col>
                                                <v-col>{{ upload.id }}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">Estado:</v-col>
                                                <v-col>{{ upload.estado.titulo }}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">Comentario:</v-col>
                                                <v-col class="text-justify">{{ upload.comentario }}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">Fecha:</v-col>
                                                <v-col>{{ formatDate(upload.fecha) }}</v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="4">Usuario:</v-col>
                                                <v-col>{{ upload.usuario.nombre }} {{ upload.usuario.apellido1 }} {{ upload.usuario.apellido2 }}</v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col v-for="file in upload.ticketUploads">
                                                    <a :href="getImgUrl(file)" target="_blank">
                                                        <img :src="getImgUrl(file)" width="300">
                                                    </a>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    <v-card elevation="0" class="pa-6 ma-4" style="background-color: rgb(255, 255, 180);">
                                        <strong>Descripción:</strong>
                                        <p>{{ ticket.descripcion }}</p>
                                    </v-card>
                                </v-card-text>
                                </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-col>
            </v-row>
        </v-expansion-panels>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { formatDate, formatDateLarge } from '@/util/libUtil.js';

export default {
    name: 'tickets',
    data: () => ({

    }),
    methods: {
        formatDate,
        formatDateLarge,
        getImgUrl(file) {
            return `https://api.retailx.es/${file.file}`;
        },
    },
    computed: {
        filteredTickets() {
            return this.tickets.filter((ticket) => {
                // if some field in ticket has the search string, return true
                return Object.values(ticket).some((value) => {
                    if (typeof value === 'string') {
                        return value.toLowerCase().includes(this.search.toLowerCase());
                    }
                    return false;
                });
            });
        },
        ...mapState('retailX', {
            tickets: (state) => state.tickets,
        }),
        ...mapState({
			search: (state) => state.util.navBarSearchField,
		}),
    },
}
</script>